module.exports = __webpack_public_path__ + "img/icon-familiar.eb77b779.svg";